import { css } from '@emotion/react'

const Styles = () => {
  return ({
    mainContent: css`
      max-width: 82rem;
      margin: 0 auto;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: column;
      @media (max-width: 768px) { 
        padding: 0 1rem 2.5rem 1rem;
      }
      h4{
        padding-bottom: 1.5rem;
        text-align: center;
      }
      
    `,
    galleryResize: css`
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      transition: transform 0ms ease 0ms;
      transform: translate3d(-0, 0, 0) !important;
      margin: 0 0 4.375rem;
      @media (max-width: 768px) { 
        margin: 0;
      }
    `,
    subtitle: css`
      padding-bottom: 2.813rem;
      text-align: center;
    `
  })
}

export { Styles }
